const Config = {
  resumeLink: 'https://drive.google.com/file/d/115e0pWaQSrutzFk8UGOFQYuqpojEfjAx/view?usp=sharing',
  twitterLink: 'https://www.x.com',
  linkedinLink: 'https://www.linkedin.com/in/productdesignerjunaid/',
  whatsapp: 'https://wa.me/971589789768',
  telecom: 'https://www.du.ae'

};

export default Config;